import { BiMoon, BiSun } from 'react-icons/bi';
import { useTheme } from '../../../../hooks/theme';

export const Theme = () => {
  const { theme, changeTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={() => changeTheme(theme === 'light' ? 'dark' : 'light')}
      className="btn-actions"
    >
      {theme === 'light' ? <BiMoon /> : <BiSun />}
    </button>
  );
};
